<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down mr10"
          @click="downloadDoctorsFile"
          >下载模板文件</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add mr10"
          @click="addDoctors"
          >批量创建医生</el-button
        >
        <el-select
          v-model="studio_id"
          class="handle-select mr10"
          @change="selectHandle"
          v-show="select_arr.length > 0"
        >
          <el-option
            v-for="(child, index) in select_arr"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="keywords"
          placeholder="请输入姓名、医院"
          class="handle-input mr10"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          class="mr10"
          @click="handleSearch"
          >搜索</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportdoctorlist"
          >导出医生信息</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="医生ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="hospital"
          label="所属医院"
          align="center"
        ></el-table-column>
        <el-table-column label="推荐状态" align="center">
          <template slot-scope="scope">{{
            getRecommendName(scope.row.is_recommend)
          }}</template>
        </el-table-column>
        <el-table-column label="封禁状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.enable == 1">未封禁</span>
            <span v-else>已封禁</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleLook(scope.row)"
              >问诊记录</el-button
            >
            <el-button
              v-if="scope.row.enable == 1"
              type="text"
              @click="handleEdit(scope.row)"
              >封禁</el-button
            >
            <el-button type="text" v-else @click="handleEdit(scope.row)"
              >解禁</el-button
            >
            <el-button type="text" @click="handleFixed(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :page-count="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="form.status"
            class="handle-select"
            @change="statusChange"
          >
            <el-option
              v-for="(child, index) in status_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封禁说明" prop="remark" v-show="remark_show">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="form.remark"
            @input="onInput()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="winddowEditVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="handle-del mr10"
          @click="delAllSelection"
          >批量删除</el-button
        >
        <el-select
          v-model="window_type"
          style="width: 200px"
          class="handle-select mr10"
          @change="handleSelectWindow"
        >
          <el-option
            v-for="(child, index) in window_types"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="sex_id"
          style="width: 200px"
          class="handle-select mr10"
          @change="handleSelectWindow"
        >
          <el-option
            v-for="(child, index) in sex_types"
            :key="index"
            :label="child.name"
            :value="child.id"
          ></el-option>
        </el-select>
        <el-input v-model="window_keyword" class="handle-input mr10"></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleWindowSearch"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="windowTableData"
        border
        class="table"
        ref="windowMultipleTable"
        header-cell-class-name="table-header"
        v-loading="window_loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
        ></el-table-column>
        <el-table-column label="性别" align="center">
          <template slot-scope="scope">{{
            getSexType(scope.row.sex)
          }}</template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">{{
            getWindowType(scope.row.type)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="area"
          label="地区"
          align="center"
        ></el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">{{
            formatDate(scope.row.created_at)
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleWindowDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="windowTotalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="windowCurrentPage"
          :page-size="window_page_size"
          :total="windowPageTotal"
          @current-change="handleWindowPageChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="downloadVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="使用说明：">
          <p>1.下载模板文件并解压;</p>
          <p>
            2.在 doctors/doctors.xlsx
            文件内填写医生信息，如果有图片需要上传的，将图片放入
            doctors/picturs文件下，excel表格中填写该图片的名称；
          </p>
          <p>3.填写完成后将doctors重新压缩成zip包并上传。</p>
        </el-form-item>
        <el-form-item label="上传：">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeZipUpload"
          >
            <em
              v-show="!uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="fixedVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form :model="fixed_form" label-width="160px">
        <el-form-item label="姓名：" v-show="!fixed_show.name">
          <span class="fc mr10">{{ fixed_form.name }}</span>
          <el-button type="primary" class="mr10" @click="handleToFixed('name')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="姓名：" v-show="fixed_show.name">
          <el-input
            v-model="fixed_change.name"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('name')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('name')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="头像：" v-show="!fixed_show.avatar">
          <el-image
            class="look-thumb"
            :src="fixed_form.avatar"
            :preview-src-list="[fixed_form.avatar]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('avatar')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="头像：" v-show="fixed_show.avatar">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="fixed_form.avatar"
              :src="fixed_form.avatar"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!fixed_form.avatar && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('avatar')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item label="性别：" v-show="!fixed_show.sex">
          <span class="fc mr10">{{ getSexType(fixed_form.sex) }}</span>
          <el-button type="primary" class="mr10" @click="handleToFixed('sex')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="性别：" v-show="fixed_show.sex">
          <el-select v-model="doctor_sex_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in window_sex_types"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('sex')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('sex')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="职称：" v-show="!fixed_show.title_id">
          <span class="fc mr10">{{ getTitleName(fixed_form.title_id) }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('title_id')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="职称：" v-show="fixed_show.title_id">
          <el-select v-model="doctor_title_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in title_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('title_id')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('title_id')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="科室：" v-show="!fixed_show.department_id">
          <span class="fc mr10">{{
            getDepartmentName(fixed_form.department_id)
          }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('department_id')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="科室：" v-show="fixed_show.department_id">
          <el-select v-model="doctor_department_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in department_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('department_id')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('department_id')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="签约状态：" v-show="!fixed_show.is_sign">
          <span class="fc mr10">{{ getSignName(fixed_form.is_sign) }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('is_sign')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="签约状态：" v-show="fixed_show.is_sign">
          <el-select v-model="doctor_sign_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in sign_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('is_sign')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('is_sign')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="推荐状态：" v-show="!fixed_show.is_recommend">
          <span class="fc mr10">{{
            getRecommendName(fixed_form.is_recommend)
          }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('is_recommend')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="推荐状态：" v-show="fixed_show.is_recommend">
          <el-select v-model="doctor_recommend_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in recommend_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('is_recommend')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('is_recommend')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="擅长：" v-show="!fixed_show.skill">
          <span class="fc mr10">{{ fixed_form.skill }}</span>
          <el-button type="primary" class="mr10" @click="handleToFixed('skill')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="擅长：" v-show="fixed_show.skill">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="fixed_change.skill"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('skill')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('skill')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="简介：" v-show="!fixed_show.introduction">
          <span class="fc mr10">{{ fixed_form.introduction }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('introduction')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="简介：" v-show="fixed_show.introduction">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="fixed_change.introduction"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('introduction')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('introduction')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="所属医院：" v-show="!fixed_show.hospital">
          <span class="fc mr10">{{ fixed_form.hospital }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('hospital')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="所属医院：" v-show="fixed_show.hospital">
          <el-input
            v-model="fixed_change.hospital"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('hospital')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('hospital')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="出诊信息：" v-show="!fixed_show.visit_info">
          <span class="fc mr10">{{ fixed_form.visit_info }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('visit_info')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="出诊信息：" v-show="fixed_show.visit_info">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="fixed_change.visit_info"
            @input="onInput()"
            class="handle-input mr10"
          ></el-input>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('visit_info')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('visit_info')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="主治疾病：" v-show="!fixed_show.diseases">
          <span class="fc mr10">{{
            getDiseasesName(fixed_form.diseases)
          }}</span>
          <el-button type="primary" class="mr10" @click="handleToDiseases()"
            >修改</el-button
          >
        </el-form-item>

        <!--        <el-form-item label="出诊信息：" v-show="!fixed_show.visit_info">-->
        <!--          <span class="fc mr10">{{fixed_form.visit_info}}</span>-->
        <!--          <el-button type="primary" class="mr10" @click="handleToFixed('visit_info')">修改</el-button>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="出诊信息：" v-show="fixed_show.visit_info">-->
        <!--          <el-input-->
        <!--            type="textarea"-->
        <!--            :autosize="{ minRows: 2, maxRows: 8}"-->
        <!--            v-model="fixed_change.visit_info"-->
        <!--            @input="onInput()"-->
        <!--            class="handle-input mr10"-->
        <!--          ></el-input>-->
        <!--          <el-button type="primary" class="mr10" @click="handleFixedConfirm('visit_info')">确定</el-button>-->
        <!--          <el-button type="primary" @click="handleFixedCancel('visit_info')">取消</el-button>-->
        <!--        </el-form-item>-->

        <el-form-item label="地区：" v-show="!fixed_show.area_json">
          <span class="fc mr10">{{ getAreaName(fixed_form.area_json) }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('area_json')"
            >修改</el-button
          >
        </el-form-item>

        <el-form-item
          label="省份："
          prop="province"
          v-show="fixed_show.area_json"
        >
          <el-select
            v-model="doctor_province"
            placeholder="请选择"
            class="handle-select"
            style="width: 160px"
            @change="handleProvinceSelect"
          >
            <el-option
              v-for="(child, index) in provinces"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="市(区)："
          prop="city"
          v-show="fixed_show.area_json && city_show"
        >
          <el-select
            v-model="doctor_city"
            placeholder="请选择"
            class="handle-select"
            style="width: 160px"
            @change="handleCitySelect"
          >
            <el-option
              v-for="(child, index) in citys"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="区(县)："
          prop="street"
          v-show="fixed_show.area_json"
        >
          <el-select
            v-model="doctor_street"
            placeholder="请选择"
            class="handle-select"
            style="width: 160px"
          >
            <el-option
              v-for="(child, index) in streets"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('area_json')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('area_json')"
            >取消</el-button
          >
        </el-form-item>
        <el-form-item
          label="服务类型："
          v-show="is_has_service && !fixed_show.service_type"
        >
          <span class="fc mr10">{{
            getServiceName(fixed_form.service_type)
          }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('service_type')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="服务类型："
          v-show="is_has_service && fixed_show.service_type"
        >
          <el-select v-model="doctor_service_id" class="handle-select mr10">
            <el-option
              v-for="(child, index) in service_ids"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('service_type')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('service_type')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item
          label="服务价格："
          v-show="is_has_service && !fixed_show.service_price"
        >
          <span class="fc mr10">{{ fixed_form.service_price }}</span>
          <el-button
            type="primary"
            class="mr10"
            @click="handleToFixed('service_price')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="服务价格："
          v-show="is_has_service && fixed_show.service_price"
        >
          <el-select v-model="doctor_service_price" class="handle-select mr10">
            <el-option
              v-for="(child, index) in service_prices"
              :key="index"
              :label="child"
              :value="child"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="mr10"
            @click="handleFixedConfirm('service_price')"
            >确定</el-button
          >
          <el-button type="primary" @click="handleFixedCancel('service_price')"
            >取消</el-button
          >
        </el-form-item>

        <el-form-item label="身份证正面：" v-show="!fixed_show.id_back_url">
          <el-image
            class="look-thumb"
            :src="fixed_form.id_back_url"
            :preview-src-list="[fixed_form.id_back_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('id_back_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="身份证正面：" v-show="fixed_show.id_back_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeidbackPhotoUpload"
          >
            <img
              v-if="fixed_form.id_back_url"
              :src="fixed_form.id_back_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.id_back_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('id_back_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item label="身份证反面：" v-show="!fixed_show.id_front_url">
          <el-image
            class="look-thumb"
            :src="fixed_form.id_front_url"
            :preview-src-list="[fixed_form.id_front_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('id_front_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="身份证反面：" v-show="fixed_show.id_front_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeidfrontPhotoUpload"
          >
            <img
              v-if="fixed_form.id_front_url"
              :src="fixed_form.id_front_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.id_front_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('id_front_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="医师资格证信息页："
          v-show="!fixed_show.doctor_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.doctor_certificate_info_url"
            :preview-src-list="[fixed_form.doctor_certificate_info_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_certificate_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证信息页："
          v-show="fixed_show.doctor_certificate_info_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforecertificateUpload"
          >
            <img
              v-if="fixed_form.doctor_certificate_info_url"
              :src="fixed_form.doctor_certificate_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.doctor_certificate_info_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_certificate_info_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="医师资格证照片页："
          v-show="!fixed_show.doctor_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.doctor_certificate_photo_url"
            :preview-src-list="[fixed_form.doctor_certificate_photo_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_certificate_photo_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师资格证照片页："
          v-show="fixed_show.doctor_certificate_photo_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforecertificatePhotoUpload"
          >
            <img
              v-if="fixed_form.doctor_certificate_photo_url"
              :src="fixed_form.doctor_certificate_photo_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.doctor_certificate_photo_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_certificate_photo_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="医师执业证书照片页："
          v-show="!fixed_show.doctor_practice_certificate_photo_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.doctor_practice_certificate_photo_url"
            :preview-src-list="[
              fixed_form.doctor_practice_certificate_photo_url,
            ]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_practice_certificate_photo_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书照片页："
          v-show="fixed_show.doctor_practice_certificate_photo_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforePracticePhotoUpload"
          >
            <img
              v-if="fixed_form.doctor_practice_certificate_photo_url"
              :src="fixed_form.doctor_practice_certificate_photo_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="
                !fixed_form.doctor_practice_certificate_photo_url && !uploading
              "
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_practice_certificate_photo_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="医师执业证书信息页："
          v-show="!fixed_show.doctor_practice_certificate_info_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.doctor_practice_certificate_info_url"
            :preview-src-list="[
              fixed_form.doctor_practice_certificate_info_url,
            ]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('doctor_practice_certificate_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医师执业证书信息页："
          v-show="fixed_show.doctor_practice_certificate_info_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforePracticeInfoUpload"
          >
            <img
              v-if="fixed_form.doctor_practice_certificate_info_url"
              :src="fixed_form.doctor_practice_certificate_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="
                !fixed_form.doctor_practice_certificate_info_url && !uploading
              "
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('doctor_practice_certificate_info_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="医生职称证书："
          v-show="!fixed_show.title_certificate_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.title_certificate_url"
            :preview-src-list="[fixed_form.title_certificate_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('title_certificate_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item
          label="医生职称证书："
          v-show="fixed_show.title_certificate_url"
        >
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeTitleUpload"
          >
            <img
              v-if="fixed_form.title_certificate_url"
              :src="fixed_form.title_certificate_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.title_certificate_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button
            type="primary"
            @click="handleFixedCancel('title_certificate_url')"
            >保存</el-button
          >
        </el-form-item>

        <el-form-item
          label="卫健委信息截图："
          v-show="!fixed_show.NHC_info_url"
        >
          <el-image
            class="look-thumb"
            :src="fixed_form.NHC_info_url"
            :preview-src-list="[fixed_form.NHC_info_url]"
          ></el-image>
          <el-button
            type="primary"
            class="ml10"
            @click="handleToFixed('NHC_info_url')"
            >修改</el-button
          >
        </el-form-item>
        <el-form-item label="卫健委信息截图：" v-show="fixed_show.NHC_info_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeNHCInfoUpload"
          >
            <img
              v-if="fixed_form.NHC_info_url"
              :src="fixed_form.NHC_info_url"
              class="avatar"
              alt="暂未上传"
            />
            <em
              v-show="!fixed_form.NHC_info_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
          <el-button type="primary" @click="handleFixedCancel('NHC_info_url')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="closeFixed">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="diseasesVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form :model="fixed_form" label-width="160px">
        <el-tree
          :data="diseases_ids"
          show-checkbox
          node-key="id"
          :default-expanded-keys="tree_expanded_keys"
          :default-checked-keys="tree_checked_keys"
          ref="treeDiseases"
          :props="defaultProps"
        ></el-tree>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="handleConfirmDiseases"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/iapetusApiConfig";
import http2 from "../../../api/uploadApiConfig";
import http3 from "../../../api/hemeraApiConfig";
import VUE_APP_API_IAPETUS_URL from "../../../api/getapi/iapetus";
import $ from "jquery";
export default {
  name: "Doctorlist",
  data() {
    return {
      select_arr: [{ id: "", name: "全部" }],
      status_types: [
        { label: "解禁", value: 1 },
        { label: "封禁", value: 2 },
      ],
      studio_id: "",
      excelData: [],
      excel_current: 1,
      excel_totals: 1,
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 0,
      keywords: "",
      loading: false,
      windowTableData: [],
      windowCurrentPage: 1,
      windowTotalPages: 1,
      window_page_size: 10,
      windowPageTotal: 10,
      window_keyword: "",
      window_loading: false,
      window_types: [
        { name: "全部", id: "" },
        { name: "未支付", id: 0 },
        { name: "待接诊", id: 1 },
        { name: "问诊中", id: 2 },
        { name: "已结束", id: 3 },
        { name: "付款后未接诊退款", id: 4 },
      ],
      window_type: "",
      select_user_id: 1,
      sex_types: [
        { name: "全部", id: "" },
        { name: "男", id: 1 },
        { name: "女", id: 0 },
      ],
      sex_id: "",
      winddowEditVisible: false,
      remark_show: false,
      multipleSelection: [],
      delList: [],
      editVisible: false,
      is_add: false,
      form: {},
      submit_obj: {},
      rules: {
        remark: [
          { required: true, message: "请填写封禁说明", trigger: "blur" },
        ],
      },
      select_doctor_id: "",
      select_user_ids: "",
      downloadVisible: false,
      uploading: false,
      work_path: "common/template",
      fixedVisible: false,
      window_sex_types: [
        { name: "男", id: 1 },
        { name: "女", id: 0 },
      ],
      doctor_sex_id: "",
      fixed_form: {},
      fixed_show: {},
      fixed_change: {},
      title_ids: [],
      doctor_title_id: "",
      department_ids: [],
      doctor_department_id: "",
      provinces: [],
      doctor_province: "",
      citys: [],
      doctor_city: "",
      streets: [],
      doctor_street: "",
      city_show: false,
      diseases_ids: [],
      sign_ids: [
        { name: "已签约", id: 1 },
        { name: "未签约", id: 0 },
      ],
      doctor_sign_id: "",
      recommend_ids: [
        { name: "已推荐", id: 1 },
        { name: "未推荐", id: 0 },
      ],
      doctor_recommend_id: "",
      service_ids: [{ name: "图文对话", id: 1 }],
      doctor_service_id: "",
      service_prices: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100,
        200, 300, 400, 500, 600, 700, 800, 900, 1000,
      ],
      is_has_service: false,
      doctor_service_price: "",
      diseasesVisible: false,
      defaultProps: {
        children: "list",
        label: "name",
      },
      tree_expanded_keys: [],
      tree_checked_keys: [],
    };
  },
  created() {
    let that = this;
    http.get("/admin/studios").then(function (res) {
      that.select_arr = that.select_arr.concat(res.data.data.items);
      that.$set(that.select_arr);
    });
    that.getData();
    http.get("/common/titles").then(function (res) {
      that.title_ids = res.data.data;
    });
    http.get("/common/departments").then(function (res) {
      that.department_ids = res.data.data;
    });
    http.get("/studio/departments").then(function (res) {
      that.diseases_ids = res.data.data;
    });
    http3.get("/areas/0").then(function (res) {
      that.provinces = res.data.data;
    });
  },
  methods: {
    getAreaName(json) {
      let province = "";
      let city = "";
      let street = "";
      if (json) {
        let area = JSON.parse(json);
        province = area[0]["name"];
        if (area[1]["name"] != "市辖区") {
          city = area[1]["name"];
        }
        street = area[2]["name"];
      }
      return province + city + street;
    },
    getDiseasesName(arr) {
      if (arr && arr.length > 0) {
        let str = "";
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]["name"];
          } else {
            str += "," + arr[i]["name"];
          }
        }
        return str;
      } else {
        return "";
      }
    },
    getServiceName(id) {
      var item = _.filter(this.service_ids, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getSignName(id) {
      var item = _.filter(this.sign_ids, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getRecommendName(id) {
      var item = _.filter(this.recommend_ids, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getTitleName(id) {
      var item = _.filter(this.title_ids, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getDepartmentName(id) {
      var item = _.filter(this.department_ids, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getTitleId(name) {
      var item = _.filter(this.title_ids, function (selector) {
        return selector.name == name;
      })[0];
      if (item) {
        return item["id"];
      } else {
        return "";
      }
    },
    getDepartmentId(name) {
      var item = _.filter(this.department_ids, function (selector) {
        return selector.name == name;
      })[0];
      if (item) {
        return item["id"];
      } else {
        return "";
      }
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    getSexType(id) {
      if (id == 0) {
        return "女";
      } else if (id == 1) {
        return "男";
      } else {
        return "未知";
      }
    },
    getWindowType(id) {
      var item = _.filter(this.window_types, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      if (that.studio_id) {
        params["studio_id"] = that.studio_id;
      }
      http.get("/admin/doctors", { params: params }).then(function (res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.items;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.loading = false;
      });
    },
    getWindowData() {
      let that = this;
      that.window_loading = true;
      let params = {
        page: that.windowCurrentPage,
        page_size: that.window_page_size,
      };
      if (that.window_keyword) {
        params["keywords"] = that.window_keyword;
      }
      if (that.window_type) {
        params["type"] = that.window_type;
      }
      if (that.sex_id) {
        params["sex"] = that.sex_id;
      }
      http
        .get("/admin/doctors/" + that.select_user_id + "/diagnosis", {
          params: params,
        })
        .then(function (res) {
          that.windowTableData = res.data.data.items;
          that.windowCurrentPage = res.data.data.current_page;
          that.windowTotalPages = res.data.data.total_pages;
          that.windowPageTotal = that.windowTotalPages * that.window_page_size;
          that.window_loading = false;
        });
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    // 删除操作
    handleDelete(index, row) {
      let that = this;
      // 二次确认删除
      //
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/messages/" + row.id).then(function (res) {
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    onInput() {
      this.$forceUpdate();
    },
    statusChange() {
      if (this.form.status == 2) {
        this.remark_show = true;
      } else {
        this.remark_show = false;
      }
    },
    // 编辑操作
    handleEdit(row) {
      let enable = row.enable;
      if (row.enable == 2) {
        this.remark_show = false;
        enable = 1;
      } else {
        this.remark_show = true;
        enable = 2;
      }
      this.form = {
        id: row.id,
        status: enable,
        remark: "",
      };
      this.editVisible = true;
    },
    //新增操作
    addEdit() {
      this.form = {
        type: 1,
        platform_type: 1,
        message: "",
        extras: "",
        devices: "",
      };
      this.is_add = true;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      if (that.form.status == 1) {
        that.form.remark = "remark";
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            status: that.form.status,
            remark: that.form.remark,
          };
          http
            .put("/admin/doctors/" + that.form.id, params)
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.getData();
              }
            });

          that.editVisible = false;
        } else {
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleSelectWindow() {
      this.windowCurrentPage = 1;
      this.getWindowData();
    },
    handleWindowSearch() {
      this.windowCurrentPage = 1;
      this.getWindowData();
    },
    handleWindowDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http
            .delete(
              "/admin/doctors/" + that.select_user_id + "/diagnosis/" + row.id
            )
            .then(function (res) {
              if (res.data.status_code == 200) {
                that.$message.success("删除成功");
                that.getWindowData();
              }
            });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection() {
      let that = this;
      const length = that.multipleSelection.length;
      if (length > 0) {
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let str = "";
            for (let i = 0; i < length; i++) {
              if (i > 0) {
                str += "," + that.multipleSelection[i].id;
              } else {
                str += that.multipleSelection[i].id;
              }
            }
            http
              .delete(
                "/admin/doctors/" + that.select_user_id + "/diagnosis/" + str
              )
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success("删除成功");
                  that.multipleSelection = [];
                  that.getWindowData();
                }
              });
          })
          .catch(() => {});
      } else {
        that.$message.warning("请最少选择一项");
      }
    },
    //查看
    handleLook(row) {
      this.select_user_id = row.id;
      this.window_type = "";
      this.sex_id = "";
      this.window_keyword = "";
      this.windowCurrentPage = 1;
      this.winddowEditVisible = true;
      this.getWindowData();
    },
    handleWindowPageChange(val) {
      this.windowCurrentPage = val;
      this.getWindowData();
    },
    downloadDoctorsFile() {
      http.get("/admin/excel/template").then(function (res) {
        window.location.href = res.data.data.template_url;
      });
    },
    // 导出医生列表 请求第一页
    exportdoctorlist() {
      let that = this;
      let params = {
        page: that.excel_current,
        page_size: 100,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      if (that.studio_id) {
        params["studio_id"] = that.studio_id;
      }
      http.get("/admin/doctors", { params: params }).then(function (res) {
        that.excelData = res.data.data.items;
        that.excel_current = res.data.data.page;
        that.excel_totals = res.data.data.total_pages;
        if (that.excel_totals == 1) {
          that.exportdoctor(that.excelData);
        } else {
          that.exportdoctoralllist();
        }
      });
    },
    // 导出医生列表 请求剩余页
    exportdoctoralllist() {
      let that = this;
      let apiURL = "";
      if (process.env.NODE_ENV === "development") {
        apiURL = "http://proxy.jiankanghao.net:50206/api/v1";
      } else {
        apiURL = VUE_APP_API_IAPETUS_URL;
      }
      apiURL = apiURL + "/admin/doctors";
      for (let i = 2; i <= this.excel_totals; i++) {
        let params = {
          page: that.excel_current,
          page_size: 100,
        };
        if (that.keywords) {
          params["keywords"] = that.keywords;
        }
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function (data) {
            if (data.status_code == 200) {
              that.excelData = that.excelData.concat(data.data.items);
              that.excel_current += 1;
              that.excel_totals = data.data.total_pages;
            }
          },
          error: function (e) {
            console.log(e.responseText);
          },
        });
      }
      this.exportdoctor(that.excelData);
    },
    // 导出医生列表 导出方法
    exportdoctor(res) {
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = ["姓名", "手机号", "所属医院", "是否推荐", "封禁状态"];
        const filterVal = [
          "name",
          "phone",
          "hospital",
          "is_recommend",
          "enable",
        ];
        const list = res;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "医生信息列表");
        that.excelData = [];
        that.excel_current = 1;
        that.excel_totals = 1;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    addDoctors() {
      this.downloadVisible = true;
    },
    beforeZipUpload(file) {
      let that = this;
      // const isZip = file.type === "application/x-zip-compressed";
      //获取最后一个.的位置
      var index = file.name.lastIndexOf(".");
      //获取后缀
      var ext = file.name.substring(index + 1);
      //输出结果
      if (ext == "zip") {
        var ossData = new FormData();
        ossData.append("excel", file);
        that.uploading = true;
        http.post("/admin/batch_doctors", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.downloadVisible = false;
          }
          that.uploading = false;
        });
      } else {
        this.$message.error("上传文件不是zip文件");
      }
      return ext;
    },
    handleFixed(row) {
      let that = this;
      that.select_doctor_id = row.id;
      that.select_user_ids = row.user_id;
      http.get("/admin/doctors/" + row.id + "/info").then(function (res) {
        that.fixed_form = res.data.data;
        that.fixed_show = {};
        that.fixed_form["title_id"] = that.getTitleId(that.fixed_form["title"]);
        if (that.fixed_form["services"].length > 0) {
          that.fixed_form["service_type"] =
            that.fixed_form["services"][0]["type"];
          that.fixed_form["service_price"] =
            that.fixed_form["services"][0]["price"];
          that.is_has_service = true;
        } else {
          that.is_has_service = false;
        }
        for (let key in that.fixed_form) {
          that.fixed_show[key] = false;
        }
        that.fixedVisible = true;
      });
    },
    putDoctor(key, value, init) {
      let that = this;
      let params = {};
      params[key] = value;
      if (key == "service_type") {
        params["service_price"] = that.fixed_form["service_price"];
      } else if (key == "service_price") {
        params["service_type"] = that.fixed_form["service_type"];
      } else if (key == "area_json") {
        params["area"] = that.getAreaName(value);
      }
      http
        .put("/admin/doctors/" + that.select_doctor_id + "/info", params)
        .then(function (res) {
          if (res.data.status_code == 200) {
            if (init) {
              that.getData();
            }
          }
        });
    },
    handleToDiseases() {
      let that = this;
      that.tree_expanded_keys = [];
      that.tree_checked_keys = [];
      if (
        that.fixed_form["diseases"] &&
        that.fixed_form["diseases"].length > 0
      ) {
        for (let i = 0; i < that.fixed_form["diseases"].length; i++) {
          that.tree_checked_keys.push(that.fixed_form["diseases"][i]["id"]);
        }
        for (let j = 0; j < that.diseases_ids.length; j++) {
          for (let k = 0; k < that.fixed_form["diseases"].length; k++) {
            let arr = _.filter(
              that.diseases_ids[j]["list"],
              function (selector) {
                return selector.id == that.fixed_form["diseases"][k]["id"];
              }
            );
            if (arr.length > 0) {
              that.tree_expanded_keys.push(that.diseases_ids[j]["id"]);
              break;
            }
          }
        }
      }
      that.diseasesVisible = true;
    },
    handleConfirmDiseases() {
      let diseases = [];
      let diseases_ids = "";
      let diseases_nodes = this.$refs.treeDiseases.getCheckedNodes();
      if (diseases_nodes.length > 0) {
        for (let i = 0; i < diseases_nodes.length; i++) {
          if (!diseases_nodes[i]["list"]) {
            diseases.push(diseases_nodes[i]);
            if (diseases_ids == "") {
              diseases_ids = diseases_nodes[i]["id"];
            } else {
              diseases_ids += "," + diseases_nodes[i]["id"];
            }
          }
        }
      }
      this.fixed_form["diseases"] = diseases;
      this.$forceUpdate();
      this.putDoctor("diseases", diseases_ids, false);
      this.diseasesVisible = false;
    },
    handleProvinceSelect() {
      let that = this;
      that.doctor_city = "";
      that.doctor_street = "";
      http3.get("/areas/" + that.doctor_province).then(function (res) {
        that.streets = [];
        that.citys = res.data.data;
        if (that.citys[0]["name"] == "市辖区") {
          that.city_show = false;
          that.doctor_city = that.citys[0]["id"];
          http3.get("/areas/" + that.doctor_city).then(function (res) {
            that.streets = res.data.data;
          });
        } else {
          that.city_show = true;
        }
      });
    },
    handleCitySelect() {
      let that = this;
      that.doctor_street = "";
      http3.get("/areas/" + that.doctor_city).then(function (res) {
        that.streets = res.data.data;
      });
    },
    handleToFixed(key) {
      let that = this;
      that.fixed_change = {};
      if (key == "sex") {
        that.doctor_sex_id = that.fixed_form[key];
      } else if (key == "title_id") {
        that.doctor_title_id = that.fixed_form[key];
      } else if (key == "department_id") {
        that.doctor_department_id = that.fixed_form[key];
      } else if (key == "is_sign") {
        that.doctor_sign_id = that.fixed_form[key];
      } else if (key == "is_recommend") {
        that.doctor_recommend_id = that.fixed_form[key];
      } else if (key == "service_type") {
        that.doctor_service_id = that.fixed_form["service_type"];
      } else if (key == "service_price") {
        that.doctor_service_price = that.fixed_form["service_price"];
      } else if (key == "area_json") {
        that.doctor_province = "";
        that.doctor_city = "";
        that.doctor_street = "";
        if (that.fixed_form["area_json"]) {
          let area = JSON.parse(that.fixed_form["area_json"]);
          that.doctor_province = area[0]["id"];
          that.doctor_city = area[1]["id"];
          that.doctor_street = area[2]["id"];
          if (that.doctor_province) {
            http3.get("/areas/" + that.doctor_province).then(function (res) {
              that.citys = res.data.data;
            });
          }
          if (that.doctor_province) {
            http3.get("/areas/" + that.doctor_city).then(function (res) {
              that.streets = res.data.data;
            });
          }
          if (area[1]["name"] == "市辖区") {
            that.city_show = false;
          } else {
            that.city_show = true;
          }
        }
      } else {
        that.fixed_change[key] = that.fixed_form[key];
      }
      that.$set(that.fixed_show, key, true);
      that.$forceUpdate();
    },
    handleFixedConfirm(key) {
      let that = this;
      if (key == "sex") {
        that.fixed_form[key] = that.doctor_sex_id;
      } else if (key == "title_id") {
        that.fixed_form[key] = that.doctor_title_id;
      } else if (key == "department_id") {
        that.fixed_form[key] = that.doctor_department_id;
      } else if (key == "is_sign") {
        that.fixed_form[key] = that.doctor_sign_id;
      } else if (key == "is_recommend") {
        that.fixed_form[key] = that.doctor_recommend_id;
      } else if (key == "service_type") {
        that.fixed_form["service_type"] = that.doctor_service_id;
      } else if (key == "service_price") {
        that.fixed_form["service_price"] = that.doctor_service_price;
      } else if (key == "area_json") {
        let area = [];
        let province_obj = _.filter(that.provinces, function (selector) {
          return selector.id === that.doctor_province;
        })[0];
        let city_obj = _.filter(that.citys, function (selector) {
          return selector.id === that.doctor_city;
        })[0];
        let street_obj = _.filter(that.streets, function (selector) {
          return selector.id === that.doctor_street;
        })[0];
        if (province_obj) {
          area.push(province_obj);
        }
        if (city_obj) {
          area.push(city_obj);
        }
        if (street_obj) {
          area.push(street_obj);
        }
        if (area.length > 0) {
          that.fixed_form["area_json"] = JSON.stringify(area);
        } else {
          that.fixed_form["area_json"] = "";
        }
      } else {
        that.fixed_form[key] = this.fixed_change[key];
      }
      that.$set(that.fixed_show, key, false);
      that.$forceUpdate();
      if (key == "name" || key == "hospital" || key == "is_recommend") {
        that.putDoctor(key, that.fixed_form[key], true);
      } else {
        that.putDoctor(key, that.fixed_form[key], false);
      }
    },
    handleFixedCancel(key) {
      this.$set(this.fixed_show, key, false);
      this.$forceUpdate();
    },
    closeFixed() {
      this.fixedVisible = false;
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", `user/` + that.select_user_ids + `/avatar`);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.avatar_path =
              `user/` + that.select_user_ids + `/avatar/` + filename;
            that.fixed_form.avatar = URL.createObjectURL(file);
            that.putDoctor("avatar_path", that.fixed_form.avatar_path, false);
            that.$set(that.fixed_show, "avatar", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeTitleUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_professional`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.title_certificate_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_professional/` +
              filename;
            that.fixed_form.title_certificate_url = URL.createObjectURL(file);
            that.putDoctor(
              "title_certificate_path",
              that.fixed_form.title_certificate_path,
              false
            );
            that.$set(that.fixed_show, "title_certificate_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeidbackPhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.id_back_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.fixed_form.id_back_url = URL.createObjectURL(file);
            that.putDoctor("id_back_path", that.fixed_form.id_back_path, false);
            that.$set(that.fixed_show, "id_back_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeidfrontPhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.id_front_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.fixed_form.id_front_url = URL.createObjectURL(file);
            that.putDoctor(
              "id_front_path",
              that.fixed_form.id_front_path,
              false
            );
            that.$set(that.fixed_show, "id_front_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforecertificateUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.doctor_certificate_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.fixed_form.doctor_certificate_info_url =
              URL.createObjectURL(file);
            that.putDoctor(
              "doctor_certificate_info_path",
              that.fixed_form.doctor_certificate_info_path,
              false
            );
            that.$set(that.fixed_show, "doctor_certificate_info_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforecertificatePhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.doctor_certificate_photo_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.fixed_form.doctor_certificate_photo_url =
              URL.createObjectURL(file);
            that.putDoctor(
              "doctor_certificate_photo_path",
              that.fixed_form.doctor_certificate_photo_path,
              false
            );
            that.$set(that.fixed_show, "doctor_certificate_photo_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforePracticePhotoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_photo`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.doctor_practice_certificate_photo_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_photo/` +
              filename;
            that.fixed_form.doctor_practice_certificate_photo_url =
              URL.createObjectURL(file);
            that.putDoctor(
              "doctor_practice_certificate_photo_path",
              that.fixed_form.doctor_practice_certificate_photo_path,
              false
            );
            that.$set(
              that.fixed_show,
              "doctor_practice_certificate_photo_url",
              false
            );
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforePracticeInfoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_info`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.doctor_practice_certificate_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_info/` +
              filename;
            that.fixed_form.doctor_practice_certificate_info_url =
              URL.createObjectURL(file);
            that.putDoctor(
              "doctor_practice_certificate_info_path",
              that.fixed_form.doctor_practice_certificate_info_path,
              false
            );
            that.$set(
              that.fixed_show,
              "doctor_practice_certificate_info_url",
              false
            );
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    beforeNHCInfoUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append(
          "work_path",
          `user/certificate/doctor_` +
            that.select_doctor_id +
            `_certificate_info`
        );
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        that.$forceUpdate();
        http2.post("/upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.fixed_form.NHC_info_path =
              `user/certificate/doctor_` +
              that.select_doctor_id +
              `_certificate_info/` +
              filename;
            that.fixed_form.NHC_info_url = URL.createObjectURL(file);
            that.putDoctor(
              "NHC_info_path",
              that.fixed_form.NHC_info_path,
              false
            );
            that.$set(that.fixed_show, "NHC_info_url", false);
            that.$forceUpdate();
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
